import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./CartItem.module.css";
import CartProduct from "./CartProduct";
import "../../fonts/Futura-PT-Book.ttf";
import { useNavigate } from "react-router-dom";

import CartBox from "./CartBox";
const CartItem = () => {
  const navigate = useNavigate();
  const buttontwoSubmit = () => {
    navigate("/cart-item/details");
  };
  return (
    <div>
      <Header />
      <div className={styles.cartItem}>
        <h6 className={`${styles.carttitle}`}>お買物カート</h6>
        <CartBox />
        <div className="d-flex justify-content-center mt-5 mb-5">
          <div className="mr-3">
            <button className={styles.button1}>お買い物へ戻る</button>
          </div>
          <div className="ml-3">
            <button onClick={buttontwoSubmit} className={styles.button2}>
              ご注文手続きへ
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CartItem;
